
(function(template){
    define('vue!app/views/vue/components/cartComponent/cartBody/bookingIndicatorComponent',['Vue','vuex'],function(Vue,vuex){
        return {
            template:template,
            data: function(){
                return {
                    count: 0,
                }
            },
            computed: _.extend(vuex.mapState(['users','currentlyEditingService','activeUser','bookForAllGuestCheckBox','usersWithIds']), {
                userName: function(){
                    return this.usersWithIds[this.userId];
                },
                userId: function() {
                    return _.keys(this.users)[this.activeUser];
                },
                bookingUserIndex: function(){
                    return this.$store.state.bookingProgressPerUser;
                },
                activeStep: function(){
                    return this.$store.state.activeStep
                },
                serviceName: function () {
                    if (this.itemId) {
                        return this.users[this.userId][this.itemId].serviceName
                    }
                },
                recipientName: function () {
                    if (this.bookForAllGuestCheckBox) return this.localStrings.stepper.header.bookForAll
                    else return this.userName
                 },
                itemId: function () {
                    return Object.keys((this.users[this.userId] || {}))[this.currentlyEditingService]
                },
             
               
            }),
            methods: {
                GetCountOfGuestsPerService: function () { 
                    var vm = this
                    var count = 0;
                    _.each(vm.$store.state.users, function (user) {
                        _.values(user).forEach(function (item) {
                            if (item.service && !item.SpaFolioItemId) { count++;}
                        })
                    })
                    return count
                }
            },
            watch: {
                activeStep: function(val){
                    if(val != 1) return;
                    this.count = this.GetCountOfGuestsPerService();
                    this.$store.commit('setBookingProgressPerUser',1);
                }
            },
             mounted: function () {
                 this.count = this.GetCountOfGuestsPerService()
                 this.$store.commit('setBookingProgressPerUser', 1)
             },
            props:['is_service_booked']
        }
    })
})('<div class="cart-user-header-booking-indicator" v-if="serviceName && activeStep==1" > <label class="cart-user-header-booking-indicator-label">{{is_service_booked? \'Editing\': \'Scheduling\'}} </label> {{serviceName}} for {{recipientName.split(\'-\')[0]}} <span v-if="!bookForAllGuestCheckBox && !is_service_booked && count>1">( {{bookingUserIndex}} of {{count}} )</span> </div>');
